// --------------------------------------------------------------------------
// #237 Payment Form Toggle - between credit card or direct debit reliant on donation block
// --------------------------------------------------------------------------
// Author:      Alix Richards
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {
    var ref = { $root: options.context };
    var state = { monthly: null };
    var activeCssClass = 'active';

    function render() {
        ref.$directDebitFields.toggleClass(activeCssClass, state.monthly);
        ref.$creditCardFields.toggleClass(activeCssClass, !state.monthly);
    }

    function init() {
        ref.$creditCardFields = ref.$root.find('[data-name="credit-card"]');
        ref.$directDebitFields = ref.$root.find('[data-name="direct-debit"]');
        ref.$donationRadios = ref.$root.find('[data-name="donation-radio"]');

        ref.$root.on('change', '[data-name="donation-radio"]', function () {
            // Find the checked donation radio
            var $selectedDonationRadio = ref.$donationRadios.filter(':checked');
            // If we have a donation and the radio's ID contains 'monthly' then selected radio is monthly
            // if not then monthly is false
            // If for whatever reason no radio is selected monthly will be false
            state.monthly = !!$selectedDonationRadio.length && $selectedDonationRadio.attr('id').indexOf('monthly') !== -1;
            render();
        });

        var $selectedTab = ref.$root.find('[data-binding="donation-tabs"]').filter('.active');
        state.monthly = !!$selectedTab.length && $selectedTab.attr('data-state') === 'monthly';

        render();
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/payment-toggle.js
// module id = 274
// module chunks = 0